/**
 * focus-visible constants.
 *
 * Created via the const-add flow (subfile mode).
 */

// FOCUS

/**
 * The CSS pseudo-class the BROWSER uses to decide that a focus came from the keyboard rather than from a pointer.
 *
 * Matched against a focused element (`element.matches(FOCUS_VISIBLE_SELECTOR)`) by every control that paints a focus
 * ring only for keyboard users. `:focus` is deliberately NOT the test: it is true on a TAP as well, which paints a ring
 * on every touch press -- the regression `components/primitives/Button.tsx` records against its own onFocus handler.
 *
 * NAMED BECAUSE TWO PRIMITIVES ASK IT (`Button.tsx` and `CloseButton.tsx`) and a control whose ring rule drifted from
 * its siblings is a difference nobody sees until they are navigating by keyboard. The selector string is the whole
 * decision; the GUARD around the call is not folded with it, because the two differ on purpose -- `Button` first tests
 * that `matches` is a function (a static render or a runtime without it must read as not-focused rather than throw).
 */
export const FOCUS_VISIBLE_SELECTOR = ':focus-visible';
